import React from "react";
import { useState } from "react";
import Axios from "axios";
import { auth } from "../firebase";
import { signOut } from "firebase/auth";

export const UserContext = React.createContext({});

const API_BASE = "https://us-central1-whitesides-family-blog.cloudfunctions.net";

const UserProvider = (props) => {
  const [user, setUser] = useState({
    id: null,
    phoneNumber: null,
    fullName: null,
    groupId: null,
    subscriptionStatus: null,
    paidBy: null,
    stripeCustomerId: null,
    stripeSubscriptionId: null,
  });

  const getUser = async (phoneNumber) => {
    const res = await Axios.get(
      `${API_BASE}/getUser?phoneNumber=${encodeURIComponent(phoneNumber)}`
    );
    const data = res.data;
    setUser({
      id: data.id,
      phoneNumber: data.phoneNumber,
      fullName: data.fullName,
      groupId: data.groupId,
      subscriptionStatus: data.subscriptionStatus || "trial",
      paidBy: data.paidBy || data.id,
      stripeCustomerId: data.stripeCustomerId || null,
      stripeSubscriptionId: data.stripeSubscriptionId || null,
    });
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (_) {}
    setUser({
      id: null, phoneNumber: null, fullName: null, groupId: null,
      subscriptionStatus: null, paidBy: null, stripeCustomerId: null, stripeSubscriptionId: null,
    });
    localStorage.removeItem("phoneNumber");
    sessionStorage.removeItem("phoneNumber");
  };

  return (
    <UserContext.Provider value={{ user, setUser, getUser, handleLogout }}>
      {props.children}
    </UserContext.Provider>
  );
};

export default UserProvider;
